import React from "react";
import "./Input.scss";

const Input = ({
  type,
  label,
  name,
  required,
  autoFocus,
  autoComplete,
  placeholder,
  onChange,
  onBlur,
  lowerCase,
  value,
  error
}) => (
  <div className="Input" data-error={error ? true : false}>
    <label htmlFor={name}>{label}</label>
    <input
      onBlur={onBlur}
      onChange={onChange}
      autoFocus={autoFocus}
      autoComplete={
        type === "password" && autoComplete === false ? "new-password" : null
      }
      name={name}
      id={name}
      type={type}
      required={required}
      placeholder={placeholder}
      value={value}
      data-lowercase={lowerCase}
    />
    {error && <div className="error">{error}</div>}
  </div>
);

export default Input;
